import { render, staticRenderFns } from "./MessagePersonalizationAccordion.vue?vue&type=template&id=d3018aba&scoped=true"
import script from "./MessagePersonalizationAccordion.vue?vue&type=script&lang=js"
export * from "./MessagePersonalizationAccordion.vue?vue&type=script&lang=js"
import style0 from "./MessagePersonalizationAccordion.vue?vue&type=style&index=0&id=d3018aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3018aba",
  null
  
)

export default component.exports